module.exports = __webpack_public_path__ + "img/Weapon_96.03b9bfa1.png";